import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5436c5d9&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=5436c5d9&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436c5d9",
  null
  
)

export default component.exports